import styled from 'styled-components';
import { comum } from '../../styles/Themes/light';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    
    .error-text {
        color: ${comum.colors.primaryRed400};
        font-size: 12px;
        margin-top: 4px;
    }
`;

export const SelectorButton = styled.div<{ hasSelection: boolean }>`
    border: 1px solid ${props => props.className?.includes('error') ? comum.colors.primaryRed400 : 'var(--ceaeef3)'};
    border-radius: 8px;
    padding: 12px 16px;
    background: ${props => props.hasSelection ? 'var(--surface-input)' : comum.colors.primaryRed400};
    color: ${props => props.hasSelection ? 'var(--c353a40)' : 'white'};
    cursor: pointer;
    transition: all .3s;
    min-height: 48px;
    display: flex;
    align-items: center;
    justify-content: ${props => props.hasSelection ? 'flex-start' : 'center'};
    gap: ${props => props.hasSelection ? '0' : '8px'};
    font-size: ${props => props.hasSelection ? 'inherit' : '14px'};
    font-weight: ${props => props.hasSelection ? 'inherit' : '500'};
    
    &:hover {
        border-color: ${props => props.hasSelection ? 'var(--c798891)' : comum.colors.primaryRed400};
        background: ${props => props.hasSelection ? 'var(--surface-input)' : comum.colors.primaryRed400};
        transform: scale(1.05);
    }
    
    svg {
        width: 16px;
        height: 16px;
    }
    
    .edit-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: auto;
        
        svg {
            width: 20px;
            height: 20px;
        }
    }
    
    .selected-office {
        flex: 1;
        
        .office-name {
            font-size: 16px;
            font-weight: 500;
            color: ${'var(--c353a40)'};
            display: block;
            margin-bottom: 4px;
        }
        
        .office-codes {
            display: flex;
            align-items: center;
            gap: 8px;
            
            .code-new {
                font-size: 14px;
                font-weight: 600;
                color: ${'var(--c353a40)'};
            }
            
            .code-old {
                font-size: 12px;
                color: ${'var(--c798891)'};
            }
        }
    }
`;

export const Modal = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
`;

export const ModalContent = styled.div`
    background: ${(props: any) => props.theme.colors.interfacePure0};
    border-radius: 12px;
    width: 90%;
    max-width: 600px;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    
    .modal-footer {
        padding: 16px 24px;
        border-top: 1px solid ${(props: any) => props.theme.colors.cf3f4f6};
        display: flex;
        justify-content: space-between;
        gap: 16px;
        
        button {
            flex: 1;
            max-width: none;
        }
        
        .clear-button {
            background: transparent;
            border: 1px solid ${comum.colors.primaryRed400};
            color: ${comum.colors.primaryRed400};
            padding: 8px 16px;
            border-radius: 6px;
            cursor: pointer;
            font-size: 14px;
            transition: all .3s;
            
            &:hover {
                background: ${comum.colors.primaryRed400};
                color: ${(props: any) => props.theme.colors.pureWhite};
                transform: scale(1.05);
            }
        }
    }
`;

export const ModalHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 24px 16px;
    border-bottom: 1px solid ${(props: any) => props.theme.colors.cf3f4f6};
    
    h3 {
        margin: 0;
        font-size: 18px;
        font-weight: 600;
        color: ${'var(--c353a40)'};
    }
`;

export const CloseButton = styled.button`
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: ${'var(--c798891)'};
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    transition: all .3s;
    
    &:hover {
        background: ${(props: any) => props.theme.colors.cf3f4f6};
        color: ${'var(--c353a40)'};
        transform: scale(1.05);
    }
`;

export const SearchContainer = styled.div`
    padding: 16px 24px 12px;
    
    input {
        width: 100%;
        padding: 12px 16px;
        border: 1px solid ${(props: any) => props.theme.colors.ce5e7eb};
        border-radius: 8px;
        font-size: 16px;
        outline: none;
        transition: border-color .3s;
        
        &:focus {
            border-color: ${comum.colors.primaryBlue500};
        }
        
        &::placeholder {
            color: ${'var(--c798891)'};
        }
    }
`;

export const OfficeList = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 12px 24px 16px;
    
    .loading {
        text-align: center;
        padding: 40px 20px;
        color: ${'var(--c798891)'};
        font-size: 16px;
    }
`;

export const OfficeItem = styled.div<{ isSelected: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    border: 1px solid ${props => props.isSelected ? comum.colors.interfaceText300 : 'var(--ce5e7eb)'};
    border-radius: 8px;
    margin-bottom: 8px;
    cursor: pointer;
    transition: all .3s;
    background: ${props => props.isSelected ? 'var(--cf2f2f2)' : 'var(--surface-input)'};
    
    &:hover {
        border-color: ${comum.colors.interfaceText300};
        background: ${'var(--cf2f2f2)'};
        transform: scale(1.05);
    }
    
    .office-info {
        flex: 1;
        
        .office-name {
            font-size: 16px;
            font-weight: 600;
            color: ${'var(--c353a40)'};
            margin-bottom: 4px;
        }
        
        .office-codes {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 14px;
            
            .code-label {
                color: ${'var(--c798891)'};
            }
            
            .code-new {
                font-weight: 600;
                color: ${'var(--c353a40)'};
            }
            
            .code-separator {
                color: ${'var(--c798891)'};
            }
            
            .code-old {
                color: ${'var(--c798891)'};
            }
        }
    }
    
    .selected-tag {
        background: ${comum.colors.primaryRed400};
        color: ${(props: any) => props.theme.colors.pureWhite};
        padding: 4px 8px;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 500;
    }
`;

export const NoResultsMessage = styled.div`
    text-align: center;
    padding: 40px 20px;
    color: ${'var(--c798891)'};
    font-size: 16px;
`; 